import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { loginApple, loginEmail, loginFacebook } from '../../../../../data/auth/login'
import { UserWithTioken } from '../../../../../data/auth/data-types'
import { useAuth } from '../../../../../data/hooks/auth'

import Form from '../../../../common/form'
import { useLanguage } from '../../../../../data/state/hooks/language'
import { ForgotLink, Social, SocialLogin } from './components'
import { useAuthForms } from '../../../../common/custom-dialogs/auth'


type LoginFormProps = {
  onSuccess: () => void
  isDialog: boolean
}

const LoginForm: React.FunctionComponent<LoginFormProps> = ({ onSuccess, isDialog }) => {
    const { showRegisterForm, showForgotPasswordForm } = useAuthForms(isDialog, onSuccess)

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState<string | null>(null)

    const { full } = useLanguage()
    const { user, setAuth } = useAuth()

    const  { t } = useTranslation("authorization")

    if (user != null) {
        setTimeout(onSuccess, 100)
    }

    return (
        <Form
            title={t("login.title")}
            description="Welcome back. You’ve been missed!"
            inputs={
                [
                { type: "email", placeholder: t("labels.email"), name: "email", onChange: ev => setEmail(ev.target.value), error },
                { type: "password", placeholder: t("labels.password"), name: "password", onChange: ev => setPassword(ev.target.value) },
                ]
            }
            button_name={t("login.login_with_email")}
            button_on_tap={() => signInEmail(email, password, full, (token) => setAuth(token.user, token.token), error => setError(error))}
        >
            <ForgotLink onClick={showForgotPasswordForm}>{t("login.button_forgot_password")}</ForgotLink>
            <ForgotLink onClick={showRegisterForm}>{t("login.button_register")}</ForgotLink>   
            <Social>
                <SocialLogin 
                    src={require('./images/social/facebook.png')} 
                    onClick={() => signInFacebook(full, token => setAuth(token.user, token.token), error => setError(error))}
                />
                <SocialLogin 
                    src={require('./images/social/apple.png')}
                    onClick={() => signInApple(full, token => setAuth(token.user, token.token), error => setError(error))}
                />
            </Social>
        </Form>
    )
}


const signInEmail = async (email: string, password: string, language: string, onSuccess: (token: UserWithTioken)=>void, onError: (error: string)=>void) => {
    try {
        const { userToken, error } = await loginEmail(email, password, language)
        if (error != null) {
            console.log('Error loggin in', error)
            onError(error || 'No user with this email and password')
            return
        }

        onSuccess(userToken!)
    } catch (e) {
        console.log(e)
    }
}

const signInFacebook = async (language: string, onSuccess: (token: UserWithTioken)=>void, onError: (error: string)=>void) => {
    try {
        // @ts-ignore
        window.FB.login(async (response) => {
            const { authResponse } = response

            if (!authResponse) {
                console.log('User cancelled login or did not fully authorize.')
                console.log({ response })
                return
            }

            const { userToken, error } = await loginFacebook(authResponse.accessToken, language)
            if (error != null) {
                console.log('Error loggin in', error)
                onError(error || 'Something went wrong, try again later')
                return
            }

            onSuccess(userToken!)
        })
    } catch (e) {
        console.log(e)
        onError("Something went wrong, try again later")
    }
}

const signInApple = async (language: string, onSuccess: (token: UserWithTioken)=>void, onError: (error: string)=>void) => {
    try {
        // @ts-ignore
        const response = await window.AppleID.auth.signIn()

        console.log({ response })

        if (response.error != null) {
            onError(response.error)
            return
        }

        const { authorization: { id_token } } = response

        const { userToken, error } = await loginApple(id_token, language)
        
        if (error != null) {
            console.log('Error loggin in', error)
            onError(error || 'Something went wrong, try again later')
            return
        }

        onSuccess(userToken!)
    } catch (e) {
        console.log(e)
        onError("Something went wrong, try again later")
    }
}

export default LoginForm